<template>
  <s-form
    :title="'Package Configuration ' + formDada.title"
    v-if="!loading"
    ref="form"
    :model="formDada"
    label-width="120px"
    v-loading="pocessing"
    element-loading-text="pocessing..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <s-form-item label="Package Name" :sz="18">
      <el-input v-model="formDada.title"></el-input>
    </s-form-item>

    <s-form-item label="Disabled On" :sz="6">
      <el-row>
        <s-dater v-model="formDada.year" displayFormat="dd/MM/yyyy"></s-dater>
      </el-row>
    </s-form-item>
    <s-form-actions label="Schedulle">
      <!-- <div style="width:180px"> -->

      <span class="mini-title">on day</span>
      <el-input-number
        v-model="lastDay"
        :min="1"
        :max="100"
        style="width: 100px"
      ></el-input-number>
      <el-button
        @click="addDay()"
        :title="'add day on day ' + lastDay"
        type="success"
        style="float: right"
      >
        <fa icon="calendar-plus" fixed-width></fa>
      </el-button>
      <!-- </div> -->
    </s-form-actions>
    <s-form-item>
      <el-tree
        :data="formDada.packagescript"
        node-key="id"
        :props="{ children: 'actions' }"
        default-expand-all
        :expand-on-click-node="false"
        draggable
        @node-drop="handleDropAction"
        :allow-drop="allowDrop"
      >
        <el-row
          :class="{ 'day-row': data.dayNum }"
          style="width: 90%"
          slot-scope="{ node, data }"
        >
          <template v-if="data.dayNum">
            <el-col :md="4">
              DAY:
              <el-input-number
                title="start day"
                v-model="data.dayNum"
                :min="1"
                :max="100"
                style="width: 100px"
              ></el-input-number>
            </el-col>
            <el-col :md="2">
              <el-button
                type="warning"
                size="mini"
                round
                @click="() => removeAction(node, data)"
                title="remove day"
              >
                <fa icon="minus" fixed-width></fa>
                <fa icon="calendar-times" fixed-width></fa>
              </el-button>
            </el-col>
          </template>

          <template v-else>
            <el-col :md="1" :title="data.id">
              <fa icon="running" fixed-width></fa>
            </el-col>

            <el-col :md="10">
              <el-row>
                <s-remote-select
                  title="Suggested sapplier servise"
                  v-model="data.product_id"
                  @change-option-data="
                    (e) =>
                      (data.kind =
                        e && e.product !== undefined ? e.product : data.kind)
                  "
                  class-model="pricerules"
                  query-prop="q"
                  label-prop="name"
                  :extraQueryParams="{ mode: 'select', context: 'sapplier' }"
                ></s-remote-select>
              </el-row>
              <el-row v-if="data && data.kind != 'ACCOMMODATION'">
                <el-col :md="2">
                  <fa
                    icon="location-arrow"
                    style="float: right"
                    fixed-width
                  ></fa>
                </el-col>

                <el-col :md="10">
                  <s-remote-select
                    title="Suggested location"
                    v-model="data.from_pup"
                    class-model="pup"
                    query-prop="q"
                    label-prop="name"
                  >
                    <template slot-scope="{ item }">
                      {{ item.name }}
                      <el-tag type="info">{{ item.loc_name }}</el-tag>
                    </template>
                  </s-remote-select>
                </el-col>
                <el-col :md="2">
                  <fa
                    icon="chevron-right"
                    style="float: right"
                    fixed-width
                  ></fa>
                </el-col>
                <el-col :md="10">
                  <s-remote-select
                    title="Suggested location"
                    v-model="data.to_pup"
                    class-model="pup"
                    query-prop="q"
                    label-prop="name"
                  >
                    <template slot-scope="{ item }">
                      {{ item.name }}
                      <el-tag type="info">{{ item.loc_name }}</el-tag>
                    </template>
                  </s-remote-select>
                </el-col>
              </el-row>
            </el-col>
            <!-- <p>!!{{data}}</p> -->

            <el-col :md="2">
              <fa style="float: right" icon="step-forward" fixed-width></fa>
            </el-col>
            <el-col :md="3">
              <el-input-number
                title="end day"
                v-model="data.endDay"
                :min="1"
                :max="100"
                style="width: 100px"
              ></el-input-number>
            </el-col>
          </template>
          <el-col :md="6">
            <el-button
              title="add activity"
              v-if="data.dayNum"
              type="primary"
              size="mini"
              round
              @click="() => appendAction(data)"
            >
              +
              <fa icon="running" fixed-width></fa>
            </el-button>
            <el-button
              type="warning"
              v-else
              size="mini"
              round
              @click="() => removeAction(node, data)"
              title="remove activity"
            >
              <fa icon="minus" fixed-width></fa>
              <fa icon="running" fixed-width></fa>
            </el-button>
          </el-col>
        </el-row>
      </el-tree>
    </s-form-item>
    <s-form-actions slot="actions">
      <el-checkbox v-model="formDada.flash_bookings" style="color: #ff0000"
        >!!!reset all trips</el-checkbox
      >
      <sf-button
        :confirm="formDada.flash_bookings ? 'are you crazy?' : 'are you sure?'"
        type="warning"
        style="float: left"
        label="Refresh Bookings"
        @click="refreshPackageBookings()"
        >Refresh Bookings</sf-button
      >
      <!-- <el-button type="warning" @click="refreshPackageBookings()">Refresh Bookings</el-button> -->
      <s-btn-delete slot="left" @go="deleteThis()">Delete</s-btn-delete>
      <sf-button type="primary" @click="savepackage()">Save</sf-button>
      <sf-button>Cancel</sf-button>
    </s-form-actions>
    <q-dialog v-model="warningsDialog" position="top">
      <q-card style="width: 90vw" dark>
        <q-card-section class="row items-center no-wrap" v-if="warningsDialog">
          <q-card
            dark
            bordered
            class="bg-grey-9 my-card"
            v-for="logMsg in logMsgs"
          >
            <a :href="logMsg.link" target="_blank">Go to relative trip</a>
            <q-separator dark inset />
            <div v-for="relRt in logMsg.relRoutes">{{ relRt.warning }}</div>
          </q-card>

          <q-space />

          <q-btn flat round icon="close" @click="warningsDialog = false" />
        </q-card-section>
      </q-card>
    </q-dialog>
  </s-form>
</template>

<script>
import * as api from "~/api/resource";
export default {
  async mounted() {
    var vm = this;
    await this.loadpackage();

    this.loading = false;
  },
  data() {
    return {
      warningsDialog: false,
      logMsgs: null,
      lastDay: 1,
      loading: true,
      errors: {},
      pocessing: false,
      formDada: {},
      selectedFlightId: null,
      arvFlightDate: null,
      depFlightDate: null,
    };
  },
  methods: {
    async refreshPackageBookings() {
      const progress_msg = this.$message({
        message: "processing...",
        duration: 0,
      });
      this.logMsgs = null;
      var { data } = await api.fetchProcessor("tripservice/packagefactory", {
        packageId: this.formDada.id,
        flash_bookings: this.formDada.flash_bookings,
      });
      _log_("ore/////", data);
      if (data.results)
        for (const key in data.results) {
          if (data.results.hasOwnProperty(key)) {
            const element = data.results[key];
            if (element !== true) {
              ///tripsmanager/package/tripadmin/221/servises
              this.logMsgs = this.logMsgs ? this.logMsgs : [];
              this.logMsgs.push({
                relRoutes: element,
                link:
                  "/spa/#/tripsmanager/package/tripadmin/" + key + "/servises",
              });
            }
          }
        }
      progress_msg.close();
      this.$message({
        message: "trips and bookings are on place now",
        type: "success",
      });
      this.warningsDialog = !!this.logMsgs;
    },
    allowDrop(draggingNode, dropNode, type) {
      _log_(
        "tree AA drop: ",
        draggingNode.data.dayNum + "??" + dropNode.data.dayNum,
        draggingNode,
        dropNode,
        type
      );
      //  return true
      return (
        type != "inner" &&
        ((dropNode.data.dayNum && draggingNode.data.dayNum) ||
          (!dropNode.data.dayNum && !draggingNode.data.dayNum))
      );
    },
    handleDropAction(draggingNode, dropNode, dropType, ev) {
      const vm = this;
      var n = 1;
      _log_("tree drop: ", this.formDada, dropNode.label, dropType);
      // this.formDada.packagescript.forEach(element => {
      //   vm.$set(element, "dayNum", n++);
      // });
    },
    async deleteThis() {
      this.pocessing = true;

      try {
        this.formDada = await api.removeObject("tripservice", this.formDada);
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formDada);
      this.$emit("done", null);
      this.pocessing = false;
    },
    editFlight() {
      this.routeGo({
        name: "tripeditor",
        params: {
          tripid: this.selectedFlightId ? this.selectedFlightId : "new",
        },
      });
    },
    appendAction(data) {
      const newChild = {
        id: "p_" + this.uniqueKey(),
        label: "testtest",
        actions: [],
      };
      if (!data.actions) {
        this.$set(data, "actions", []);
      }
      data.actions.push(newChild);
    },

    removeAction(node, data) {
      const parent = node.parent;
      const actions = parent.data.actions || parent.data;
      const index = actions.findIndex((d) => d.id === data.id);
      actions.splice(index, 1);
      const lastDayScr = this.formDada.packagescript[
        this.formDada.packagescript.length - 1
      ];
      this.lastDay = lastDayScr.dayNum + 1;
    },
    async savepackage() {
      var days = this.formDada.packagescript;
      days.forEach((fixd) => {
        for (const key in fixd) {
          if (fixd.hasOwnProperty(key)) {
            var element = fixd[key];
            if (key == "id" && (element + "").indexOf("p_") < 0)
              fixd[key] = "p_" + fixd[key];
            if (key == "actions")
              element.forEach((elementoo) => {
                for (const ka in elementoo) {
                  if (elementoo.hasOwnProperty(ka)) {
                    var elementa = elementoo[ka];
                    if (ka == "id" && (elementa + "").indexOf("p_") < 0)
                      elementoo[ka] = "p_" + elementa;
                  }
                }
              });
          }
        }
      });
      _log_("correc2t...", days);
      this.formDada.packagescript = days;
      this.pocessing = true;
      this.formDada = await api.updateProcessor("tripservice/update", {
        ...this.formDada,
        packagescript: JSON.stringify(this.formDada.packagescript),
      });
      this.$emit("update", this.formDada);
      this.pocessing = false;
    },
    addDay() {
      this.formDada.packagescript.push({
        id: "p_" + this.uniqueKey(),

        dayNum: this.lastDay,
      });
      this.formDada.packagescript.sort((a, b) => a.dayNum - b.dayNum);
      ++this.lastDay;
    },
    async loadpackage(packageid) {
      this.loading = true;
      packageid = packageid ? packageid : this.$route.params.packageid;
      if (packageid) {
        if (packageid != "new")
          this.formDada = await api.fetchObject("tripservice", {
            id: packageid != "new" ? packageid : null,
          });
        else
          this.formDada = await api.fetchObject("tripservice", {
            kind: "PACKAGE",
          });
      }
      if (!this.formDada.packagescript || this.formDada.packagescript == "")
        this.$set(this.formDada, "packagescript", [
          { id: this.uniqueKey(), type: "day", dayNum: 1 },
          // { id: 2, label: "day2", dayNum: 2 }
        ]);
      const lastDayScr = this.formDada.packagescript[
        this.formDada.packagescript.length - 1
      ];
      this.lastDay = lastDayScr.dayNum + 1;
      this.loading = false;
    },
  },

  watch: {
    "$route.params.packageid": async function (packageid, oldval) {
      _log_("get b oo ", packageid, oldval);
      if (packageid != oldval) {
        await this.loadpackage(packageid);
        // this.loading = true;
        // var { data } = await api.fetchProcessor(
        //   "packages/vuepackage",
        //   this.$route.query
        // );
        // this.package = data.results;
        // this.loading = false;
      }
    },
  },
  computed: {},
};
</script>

<style>
.el-tree-node__content {
  height: auto;
}
.day-row {
  width: 100%;
  border-top: 1px solid grey;
  padding-top: 4px;
}
.el-tree-node__children {
  padding: 5px;
}
</style>
